import { combineReducers } from 'redux'
import doorVisualReducer from './doorVisual'
import crmReducers from './crm'
import todosReducers from './todos'
import mainReducers from './main'
import loginReducers from './login'

export default combineReducers({
    doorVisual: doorVisualReducer,
    crm: crmReducers,
    todos: todosReducers,
    main: mainReducers,
    login: loginReducers
})